import { TYPE_OF_PRODUCTS } from "./product";

export enum TYPE_OF_ATTRIBUTE {
  isRequired = "isRequired",
  isMultipleChoice = "isMultipleChoice",
}

export const TYPE_OF_ATTRIBUTES_OPTIONS = [
  { value: TYPE_OF_ATTRIBUTE.isRequired, label: "Required" },
  { value: TYPE_OF_ATTRIBUTE.isMultipleChoice, label: "Multiple-choice" },
];

export const DEFAULT_SURPLUS_DATA: Surplus = {
  id: "",
  status: "",
  groupMenuId: "",
  costPrice: 0,
  sellingPrice: 0,
  startTime: null,
  endTime: null,
  discountPercentage: 10,
  availableQuantity: 0,
  storeId: "",
  attributes: [],
  merchant_store_id: "",
  category_id: 0,
  name: "",
  description: "",
  thumbnail: "",
  images: [],
  imageUrl: "",
  videos: [],
  manufacturer: "",
  manufacturer_address: "",
  warranty: "",
  width: 0,
  height: 0,
  depth: 0,
  condition: 0,
  day_to_prepare_order: 0,
  lead_time: 0,
  sku: "",
  main_tags: null,
  sub_tags: [],
  settings: {
    is_featured: false,
  },
  type: TYPE_OF_PRODUCTS.FOOD,
  isSellingMode: false,
};

export const SURPLUS_ERROR = {
  code: "REACHED_MAXIMUM_SURPLUS_BAG_LIMIT",
  message: "You may add no more than two surplus products per store.",
};

export const DEFAULT_SURPLUS_TIME = {
  START: "00:00:00",
  END: "23:59:00",
};

export const SURPLUS_STATUS = {
  ACTIVE: "ACTIVE",
  SOLD_OUT: "SOLD_OUT",
};
